import {
  syncInboxBookings,
  checkInboxStatus,
  initiateInboxAuth,
  type ExtractedBooking,
} from "./inboxSync";

export {ExtractedBooking};

export const syncGmailBookings = async (tripId: string) => {
  const result = await syncInboxBookings(tripId, "gmail");
  if (result.status === "ok") {
    return {
      success: true,
      bookingsFound: result.data?.length ?? 0,
      bookings: result.data ?? [],
    };
  }
  return {
    success: false,
    bookingsFound: 0,
    bookings: [],
    error: result.message,
    requiresAuth: result.status === "auth",
  };
};

export const checkGmailConnection = async (): Promise<boolean> => {
  const status = await checkInboxStatus("gmail");
  return Boolean(status.connected);
};

export const initiateGmailAuth = async (): Promise<string | null> => {
  const response = await initiateInboxAuth("gmail");
  return response.authUrl || null;
};
